export enum DirectBookingErrorCodes {
    // Sold out
    SAIL_NOT_AVAILABLE = 1500,
    RATE_CODE_NOT_AVAILABLE = 1501,
    CABIN_CATEGORY_NOT_AVAILABLE = 1502,
    FLIGHTS_FOR_SAIL_NOT_AVAILABLE = 1503,
    SELECTED_AIRPORT_NOT_AVAILABLE = 1504,
    BOOKING_WITH_FLIGHTS_REQUIRED = 1505,
    BOOKING_WITHOUT_FLIGHTS_REQUIRED = 1506,
}

export const DB_SOLD_OUT_ERROR_CODES = [
    DirectBookingErrorCodes.SAIL_NOT_AVAILABLE,
    DirectBookingErrorCodes.RATE_CODE_NOT_AVAILABLE,
    DirectBookingErrorCodes.CABIN_CATEGORY_NOT_AVAILABLE,
    DirectBookingErrorCodes.FLIGHTS_FOR_SAIL_NOT_AVAILABLE,
    DirectBookingErrorCodes.SELECTED_AIRPORT_NOT_AVAILABLE,
    DirectBookingErrorCodes.BOOKING_WITH_FLIGHTS_REQUIRED,
    DirectBookingErrorCodes.BOOKING_WITHOUT_FLIGHTS_REQUIRED,
];
